import React, { useEffect, createElement } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AppRouter } from './AppRouter';
import { Layout } from './components/layout/Layout';
export function App() {
  useEffect(() => {
    // Google tag (gtag.js)
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id=G-3ND0GMDJ9C';
    document.head.appendChild(script);
    const inlineScript = document.createElement('script');
    inlineScript.textContent = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-3ND0GMDJ9C');
    `;
    document.head.appendChild(inlineScript);
  }, []);
  return <BrowserRouter data-id="element-0">
      <Layout data-id="element-1">
        <AppRouter data-id="element-2" />
      </Layout>
    </BrowserRouter>;
}